import { useUserStore } from "../stores/userStore";

/**
 * Calcola il valore massimo del filtro basato sulle collections API
 * @param collections Array di collections API con proprietà amount (valore massimo per quella collection)
 * @returns Il valore massimo tra tutti gli amount delle collections, 0 se non ci sono collections
 */
export const calculateMaxFilter = (collections: Array<{ amount: number }> = []): number => {
  if (!collections || collections.length === 0) {
    return 0;
  }
  
  // Trova la collection con il valore amount più alto (range massimo disponibile)
  const maxAmount = Math.max(...collections.map(collection => collection.amount));
  return maxAmount;
};

/**
 * Filtra le categorie selezionate dall'utente contro quelle disponibili nella sessione
 * Se l'utente non ha selezionato categorie, restituisce tutte le categorie della sessione
 * @param selectedCategories Categorie selezionate dall'utente (può essere vuoto)
 * @param sessionCategories Tutte le categorie disponibili nella sessione (filtro per API)
 * @returns Array di categorie valide da usare nel parametro 'categories' dell'API
 */
export const getValidCategories = (
  selectedCategories: Array<{ key: string; value: string }> = [],
  sessionCategories: Array<{ key: string; value: string }> = []
): Array<{ key: string; value: string }> => {
  // Se l'utente non ha selezionato categorie, usa tutte quelle della sessione
  if (selectedCategories.length === 0) {
    return sessionCategories;
  }
  
  // Altrimenti, filtra le categorie selezionate contro quelle valide della sessione
  const validKeys = sessionCategories.map(cat => cat.key);
  return selectedCategories.filter(category => validKeys.includes(category.key));
}; 